// extracted by mini-css-extract-plugin
module.exports = {"services":"services-module--services--2fzJ0","more":"services-module--more--1dU69","subdivider":"services-module--subdivider--rbbxu"};